import thesis from "./thesis";
import textbook from "./textbook";
import server from "./server";
import examination from "./examination";
import education from "./education";
import basic from "./basic";
import adultexam from "./adultexam";
import siteplatform from "./siteplatform";

/**
 * 华博特项目接口文档
 */
export default {
  thesis,
  textbook,
  server,
  examination,
  education,
  basic,
  adultexam,
  siteplatform,
};
